import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class UrlInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.indexOf('./') !== 0 && !request.url.includes('users/image')){    
            request = request.clone({ url: environment.backendConfig.backendUri + request.url, headers: request.headers });
        }
        return next.handle(request);
    }
}
